
import { canonical } from "@utils";

export default {
	name: "AppAbout",
	data() {
		return {
			reviewData: [
				{
					rating: 4.8,
					reviewCount: "28K",
					storeName: "App Store",
					reviewText:
						"I like this app. I use WF as a last result to get out of jams so that I will not get frustrated and quit very difficult games. It's easy to use while educating on new words and viewing definitions. Ad-free version helps to keep focus on the game plays!",
				},
				{
					rating: 4.5,
					reviewCount: "6.5K",
					storeName: "Google Play",
					reviewText:
						"For me it is not really a cheat but rather a helper app. I look at it as a word unscrambler with some very handy tips as an extra. WordFinder has increased my points per letter average score from 15 points to 18 points. It has increased my vocabulary and even my articulation and spelling.",
				},
			],
			competitionData: [
				{
					icon: "ic_about_phone",
					title: "Master any word game",
					description:
						"The WordFinder app supports over 20 popular word games.",
				},
				{
					icon: "ic_about_page",
					title: "Discover tips & tricks",
					description:
						"Check out our helpful articles for top word game tips and tricks.",
				},
				{
					icon: "ic_about_book",
					title: "Learn more, play smarter",
					description:
						"Use WordFinder to expand your knowledge, including word definitions.",
				},
			],
			stepsData: [
				{
					title: "Play your game",
					description:
						"Feeling stuck or want to improve your game score?",
				},
				{
					title: "Check WordFinder",
					description:
						"Enter your game tiles to unscramble letters and find words.",
				},
				{
					title: "Find answers",
					description:
						"Bask in the glory of the best word suggestions you can play.",
				},
				{
					title: "Return to your game",
					description:
						"Play your chosen word and improve your score with the results.",
				},
			],
			winData: [
				{
					title: "Words With Friends & Scrabble GO",
					description:
						"Use our Board Solver to scan your game and instantly see the highest-scoring placements.",
				},
				{
					title: "NYT Crossplay & Spelling Bee",
					description:
						"Get the edge on daily puzzles with curated word lists.",
				},
				{
					title: "Wordle & Wordscapes",
					description:
						"Solve levels and find hidden 5-letter words with ease.",
				},
				{
					title: "Competitive Play",
					description:
						"Supported dictionaries for Word Chums, Wordfeud, Word Cookies, CodyCross and many more.",
				},
			],
			builtData: [
				{
					icon: "ic_about_frame",
					title: "Screenshot Scanner",
					description:
						"Take a snap of your board in Words With Friends or Scrabble GO and let our AI find your next big move.",
				},
				{
					icon: "ic_about_search",
					title: "Advanced Unscrambler",
					description:
						"Search by starting letters, ending letters, or length. Use up to three wildcards (?) for those tricky racks.",
				},
				{
					icon: "ic_about_book",
					title: "Learn While You Play",
					description:
						"Powered by YourDictionary, every result lets you tap for definitions and synonyms, turning every win into a vocabulary lesson.",
				},
				{
					icon: "ic_about_check",
					title: "Always Up-to-Date",
					description:
						"Our community-vetted dictionaries are updated weekly so every word is valid and playable in your specific game.",
				},
			],
		};
	},
	head() {
		return {
			link: [canonical(this.$route)],
		};
	},
};
